<template>
  <div class="mt-6">
    <div>
      <div class="relative bg-white rounded-2xl shadow-md p-6 mx-auto">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2">
          <StackedField label="Encaissé par" :value="chargedBy" />
        </div>
        <div class="mt-6">
          <Table :columns="columns" :data="rows">
            <template #amount="{ row }">
              <span
                :class="['text-sm font-medium', row.billingType === 'collected' ? 'text-green-500' : 'text-red-500']"
              >
                {{ row.amount }}
              </span>
            </template>
            <template #storeCommission="{ row }">
              <span
                class="inline-flex items-center rounded-full px-2 py-1 text-xs font-medium bg-purple-100 text-purple-700"
              >
                {{ row.storeCommission }}
              </span>
            </template>
            <template #period="{ row }">
              <span class="text-sm font-medium text-gray-900">
                {{ row.period }}
              </span>
            </template>
            <template #paymentStatus="{ row }">
              <span class="text-sm font-medium text-gray-900">
                <div v-if="row.uncollectible === true">
                  {{ $t("planSaleBilling.paymentStatus.uncollectible") }}
                </div>
                <div v-else>
                  {{ $t("planSaleBilling.paymentStatus." + row.paymentStatus) }}
                </div>
              </span>
            </template>
          </Table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, StackedField, formatPrice } from "@estaly/ui";
import { mapGetters } from "vuex";

export default {
  props: ["planSaleBillings", "chargedBy"],
  components: {
    Table,
    StackedField,
  },
  data: () => {
    return {};
  },
  computed: {
    ...mapGetters("auth", ["isOrganizationOrStoreAdmin"]),

    columns() {
      const columns = [
        { label: "Montant", field: "amount", slot: "amount" },
        { label: "Période", field: "period", slot: "period" },
        { label: "Statut", field: "paymentStatus", slot: "paymentStatus" },
      ];

      if (this.isOrganizationOrStoreAdmin) {
        columns.splice(1, 0, { label: "Commission", field: "storeCommission", slot: "storeCommission" });
      }

      return columns;
    },
    rows() {
      return this.planSaleBillings.map((billing) => {
        const storeCommission = billing.commissions.find((commission) => commission.subjectType === "Store");
        const paymentStatus = billing.uncollectible ? "uncollectible" : billing.paymentStatus;
        return {
          ...billing,
          storeCommission: this.formatPrice(storeCommission?.amount),
          period: `${billing.startDate} au ${billing.endDate}`,
          amount: this.formatPrice(billing.finalPrice),
          paymentStatus: paymentStatus,
          rowClass: paymentStatus === "failed" ? "bg-red-100" : "",
        };
      });
    },
  },
  methods: {
    formatPrice,
  },
};
</script>
